import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBluetoothOff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m12.25 7.75 2-2-4.5-4v4m-4 7.5 3.188-2.813m5.312 3.813-4.5 4v-7.97m4.5 3.97-4.5-3.97m4.5 3.97 4 3.5m-8.5-7.47-8-7.53"
	})]
});
const ForwardRef = forwardRef(SvgBluetoothOff);
export { ForwardRef as ReactComponent };
